import { render, staticRenderFns } from "./club.vue?vue&type=template&id=3c32f99a"
import script from "./club.vue?vue&type=script&lang=js"
export * from "./club.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports